import { Injectable, Inject } from '@angular/core';
import { Utils, WEB_API_URL } from '../utils/common';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private _accountKey: string;
  private _pageid: string;
  private _typename: string;
  private _orgname: string;
  private _sessionId: string;
  private _stpId: string;
  private _userlcid: string;
  private _userid: string;
  private _version: string;
  private _id: string;
  private _crmSpecificVersion: string;
  private _issplittesting: string;
  private _isrss: boolean;
  private _scoreModelId: string

  get crmSpecificVersion(): string {
    return this._crmSpecificVersion;
  }

  set crmSpecificVersion(value: string) {
    this._crmSpecificVersion = value;
  }

  get orgname(): string {
    return this._orgname;
  }

  set orgname(value: string) {
    this._orgname = value;
  }

  get typename(): string {
    return this._typename;
  }

  set typename(value: string) {
    this._typename = value;
  }

  get pageid(): string {
    return this._pageid;
  }

  set pageid(value: string) {
    this._pageid = value;
  }

  get accountKey(): string {
    return this._accountKey;
  }

  set accountKey(value: string) {
    this._accountKey = value;
  }

  get sessionId(): string {
    return this._sessionId == null ? '' : this._sessionId;
  }

  set sessionId(value: string) {
    this._sessionId = value;
  }

  get userlcid(): string {
    return this._userlcid;
  }

  set userlcid(value: string) {
    this._userlcid = value;
  }

  get stpId(): string {
    return this._stpId;
  }

  set stpId(value: string) {
    this._stpId = value;
  }

  get userid(): string {
    return this._userid;
  }

  set userid(value: string) {
    this._userid = value;
  }

  get version(): string {
    return this._version;
  }

  set version(value: string) {
    this._version = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get issplittesting(): string {
    return this._issplittesting;
  }

  set issplittesting(value: string) {
    this._issplittesting = value;
  }

  get isrss(): boolean {
    return this._isrss;
  }

  set isrss(value: boolean) {
    this._isrss = value;
  }

  get scoreModelId(): string {
    return this._scoreModelId;
  }

  set scoreModelId(value: string) {
    this._scoreModelId = value;
  }

  constructor(@Inject(WEB_API_URL) public baseUrl: string) {
    this.accountKey = Utils.getParameterByName('accountKey');
    this.pageid = Utils.getParameterByName('id');
    this.typename = Utils.getParameterByName('typename');
    this.orgname = Utils.getParameterByName('orgname');
    this.sessionId = Utils.getParameterByName('sessionId');
    this.stpId = Utils.getParameterByName('stpId') || Utils.getParameterByName('stpid');

    this.userlcid = Utils.getParameterByName('userlcid', '1033');
    this.userid = Utils.getParameterByName('userid');
    this.version = Utils.getParameterByName('version');
    this.id = Utils.getParameterByName('id'); // This is the TemplateId
    this.crmSpecificVersion = Utils.getParameterByName('crmSpecificVersion');
    this.issplittesting = Utils.getParameterByName('Issplittesting', 'false');
    this.isrss = this.getRss();
    this.scoreModelId = Utils.getParameterByName('scoreModelId', null);
  }

  getUrl(resource: string) {
    return `${this.baseUrl}/${resource}?` +
      `accountKey=${this.accountKey}&` +
      `id=${this.pageid}&` +
      `userlcid=${this.userlcid}&` +
      `typeName=${this.typename}&` +
      `orgName=${this.orgname}&` +
      `callerPage=ddeditor&` +
      `userid=${this.userid}&` +
      `Issplittesting=${this.issplittesting}`;

    let result = '';
    if (this.isrss) {
      result += '&isrss=true';
    }

    return result;
  }

  getUrlExternalBase(resource: string, baseUrl: string) {
    return `${baseUrl}/${resource}?` +
      `accountKey=${this.accountKey}&` +
      `id=${this.pageid}&` +
      `userlcid=${this.userlcid}&` +
      `typeName=${this.typename}&` +
      `orgName=${this.orgname}&` +
      `callerPage=ddeditor&` +
      `userid=${this.userid}&` +
      `Issplittesting=${this.issplittesting}`;
  }

  getSessionParam() {
    if (this.sessionId !== null && this.sessionId !== '') {
      return `&sessionId=${this.sessionId}`;
    } else if (this.stpId !== null && this.stpId !== '') {
      return `&stpid=${this.stpId}`;
    }

    return '';
  }

  //TODO: I guess this need to be removed from here
  private getRss(): boolean {
    const isRssString = Utils.getParameterByName('isrss', 'false').toLowerCase();
    return (isRssString === 'true' || isRssString === '1');
  }
}
